import { Button } from './Button';

type PropsModal = {
  children?: JSX.Element | string;
  title: string;
  show: boolean;
  changeState: (value: boolean) => void;
  size: 'lg' | 'xl' | 'sm' | undefined;
  zIndex?: number;
}

export function Modal({
  children,
  title,
  show,
  changeState,
  size = 'sm',
  zIndex = undefined
}: PropsModal) {
  const modalStyle = {
    display: 'block',
    background: 'rgba(0,0,0,0.7)',
    zIndex
  };
  return (
    <div>
      {show
        && (
        <div
          className="modal show fade"
          style={modalStyle}
        >
          <div className={`modal-dialog modal-dialog-centered modal-${ size }`}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
                <Button className="btn-close" onClick={() => changeState(false)} />
              </div>
              <div className="modal-body">
                {children}
              </div>
            </div>
          </div>
        </div>
        )
      }
    </div>
  );
}

export default Modal;
